import React, { useState, useRef, useCallback } from "react";
import BasicPlayer from "../BasicPlayer/BasicPlayer";
import { v4 as uuidv4 } from "uuid";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import moment from "moment";
import Modal from "../Modal/Modal";
import RecentList from "../RecentList/RecentList";
import { useDataStore, usePlayerStore } from "../../hooks/useNavStore";
import useNew from "../../hooks/useNew";
import useScreenWidth from "../../helper/useScreenWidth";

const BasicView = ({ data, count = 1, loading }) => {
  const { setCurrentAudio } = usePlayerStore();
  const { textOnly, setAct, emailAddress } = useDataStore();
  const screenWidth = useScreenWidth();

  // const [showNew, setShowNew] = useState(true);
  // const [isNew, setIsNew] = useState(false)
  const containerRef = useRef(null); // Reference to the component
  const timeoutRef = useRef(null); // Reference for the timeout to clear it if necessary

  const blockRows = data?.block_rows || 1;
  // const columnCount =
  //   screenWidth < 1100
  //     ? 1
  //     : textOnly && blockRows === 1
  //     ? 6
  //     : data?.column_count;
  let columnCount = data?.column_count;

  const [list, setList] = useState([]);
  const [title, setTitle] = useState(null);
  const [show, setShow] = useState(false);

  const closeModal = useCallback(() => {
    setShow(false);
    // setCurrentAudio(null);
    // Your close modal logic here
  }, []);

  const multiplier = textOnly && blockRows === 1 ? 6 : columnCount * blockRows;

  // console.log(show, 'show')

  const ridLocal = localStorage.getItem("rid") || null;
  const [RID, setRID] = useState(ridLocal);

  const activityWs = (type) => {
    let action = "activity";
    let data = {
      action: action,
      data: {
        rId: RID,
        newsType: "ASP1",
        email: emailAddress,
        type,
      },
    };
    // sendMessage(JSON.stringify(data));
    setAct(JSON.stringify(data));
  };

  const isTrending = data?.category_name === "Trending";
  const isMobile = screenWidth < 1100;

  const smallLaptop = screenWidth > 1100 && screenWidth < 1500;
  const weirdLaptop = screenWidth > 100 && screenWidth < 1200;

  if (smallLaptop) columnCount = 4;
  // if (weirdLaptop) columnCount = 2;

  const headerToDisplay =
    data?.category_name === "Trending" ? "Beliebt" : data?.category_name;

  return (
    <div className={`dpa_audio px-3 md:px-4`}>
      <div className="flex items-center justify-between mb-2 border-bttm-eee">
        <button
          className="header "
          aria-label={data?.category_name}
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              setList(data.data);
              setShow(true);
              setTitle(data?.category_name);
            }
          }}
        >
          {headerToDisplay}
        </button>
        {/* <div className="flex items-center">
                </div> */}
        <button
          className="header multi_img cursor-pointer"
          onClick={() => {
            setList(data.data);
            setShow(true);
            setTitle(data?.category_name);
            activityWs(`More: ${data?.category_name}`);
          }}
          aria-label="mehr"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              setList(data.data);
              setShow(true);
              setTitle(data?.category_name);
              activityWs(`More: ${data?.category_name}`);
            }
          }}
        >
          mehr...
        </button>
      </div>

      <div
        className={`dpa_container ${isMobile ? "mob" : ""} hide-scrollbar`}
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${columnCount}, 1fr)`,
        }}
      >
        {loading &&
          [1, 2, 3, 4].map((e) => (
            <Skeleton key={e} height={"100%"} width={"100%"} count={6} />
          ))}

        {data?.data?.length > 0 &&
          data.data.slice(0, multiplier).map((e, idx) => {
            const newUuid = uuidv4();
            const date = e.display_timestamp;
            moment.locale("de"); // Set the locale to German
            const timeOnly = moment(date).format("DD.MM. HH:mm");
            const isYesterdayOrOlder = moment(e.display_timestamp).isBefore(
              moment().startOf("day").subtract(1, "days")
            );

            const duration = e.len_string;
            const title = e.title;
            const id = e.fileId;

            const catId = e.cat_id;
            const filename = e.broadcastAudio;
            const expDate = e.audio3_presigned_expires;

            return (
              <BasicPlayer
                duration={duration}
                time={timeOnly}
                title={title}
                key={id}
                id={id}
                catId={catId}
                remark={e.remark}
                url={e.previewAudioURL}
                isYesterdayOrOlder={isYesterdayOrOlder}
                downloadURL={e.broadcastAudioURL}
                filename={filename}
                catName={data?.category_name}
                expDate={expDate}
                isTrending={isTrending}
                position={idx + 1}
              />
            );
          })}
      </div>

      {show && (
        <Modal overlay title={headerToDisplay} onClose={closeModal}>
          <RecentList
            catNameProp={data?.category_name}
            list={list}
            loading={false}
            key={"2"}
          />
        </Modal>
      )}
    </div>
  );
};

export default BasicView;
